<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <!-- <ul class="nav nav-footer">
        <li class="nav-item">
          <a
            href="https://www.creative-tim.com"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >CREATIVE TIM</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://www.updivision.com"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >UPDIVISION</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://www.creative-tim.com/presentation"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >ABOUT US</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://blog.creative-tim.com"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >BLOG</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://www.creative-tim.com/license"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >LICENSES</a
          >
        </li>
      </ul> -->
      <div class="col-lg-12">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }}, desenvolvido por <a
            href="https://www.marcasite.com.br"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >Marcasite</a
          >
          .
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
